import React from 'react';
import { Text } from '@hub/text';
import { ChevronDownMediumIcon, ChevronUpMediumIcon } from '@hub/icon';
import { LinkBox, Link } from '@hub/link';
import { Stack } from '@hub/stack';
import { Button } from '@hub/button';
import analyticsUtils from '../../../helpers/analytics-utils';
import trackClickEvent from '../../../helpers/analytics-utils/track-event';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const VisitCentreTabPanel = _ref => {
  let {
    toggleOpenCentre,
    suggestedCentres,
    isOpenCentre
  } = _ref;
  return /*#__PURE__*/_jsxs(Stack, {
    direction: "row",
    gap: "spacing-xl",
    shouldWrapChildren: false,
    "data-id": "tabs_visit-centre-tab-panel_VisitCentreTabPanel_Stack",
    children: [/*#__PURE__*/_jsx(Text, {
      "data-id": "tabs_visit-centre-tab-panel_VisitCentreTabPanel_Stack_Text",
      children: /*#__PURE__*/_jsxs(Button, {
        sx: {
          bg: 'transparent',
          padding: 0,
          margin: 0,
          height: 'none',
          fontWeight: 'normal',
          textTransform: 'none',
          fontSize: 'md'
        },
        onClick: toggleOpenCentre,
        "data-id": "tabs_visit-centre-tab-panel_VisitCentreTabPanel_Text_Button",
        children: ["Visit a centre", isOpenCentre ? /*#__PURE__*/_jsx(ChevronUpMediumIcon, {
          sx: {
            marginLeft: 'spacing-sm'
          },
          "data-id": "tabs_visit-centre-tab-panel_VisitCentreTabPanel_ChevronUpMediumIcon"
        }) : /*#__PURE__*/_jsx(ChevronDownMediumIcon, {
          sx: {
            marginLeft: 'spacing-sm'
          },
          "data-id": "tabs_visit-centre-tab-panel_VisitCentreTabPanel_ChevronDownMediumIcon"
        })]
      })
    }), suggestedCentres.length && /*#__PURE__*/_jsxs(Stack, {
      direction: "row",
      gap: "spacing-md",
      "data-id": "tabs_visit-centre-tab-panel_VisitCentreTabPanel_Stack",
      children: [/*#__PURE__*/_jsx(Text, {
        sx: {
          color: 'quartz'
        },
        "data-id": "tabs_visit-centre-tab-panel_VisitCentreTabPanel_Stack_Text",
        children: "Suggested centres"
      }), suggestedCentres.map(centre => /*#__PURE__*/_jsx(LinkBox, {
        "data-id": "tabs_visit-centre-tab-panel_VisitCentreTabPanel_LinkBox",
        children: /*#__PURE__*/_jsx(Text, {
          "data-id": "tabs_visit-centre-tab-panel_VisitCentreTabPanel_LinkBox_Text",
          children: /*#__PURE__*/_jsx(Link, {
            href: "/".concat(centre.slug),
            sx: {
              _hover: {
                textDecoration: 'none'
              }
            },
            onClick: () => trackClickEvent(analyticsUtils.categories.UNIVERSAL_HEADER, analyticsUtils.actions.UNIVERSAL_HEADER_NAV_LINK_CLICK, "Suggested Centre - ".concat(centre.displayTitle)),
            "data-id": "tabs_visit-centre-tab-panel_VisitCentreTabPanel_Text_Link",
            children: centre.displayTitle
          })
        })
      }, centre.slug))]
    })]
  });
};